import { InputFieldProps, LInputField } from "./LInputField";

export const LInputRow = ({ ...props }: InputRowProps): JSX.Element => {
    return (
        <div className="field is-horizontal">
            <div className="field-body">
                <div className="columns">
                    {props.inputs.map((i, index) => {
                        return (
                            <div className={"column" + (i.isSmall ? " is-2" : "")} key={index}>
                                <LInputField
                                    label={i.label}
                                    inputName={i.inputName}
                                    type={i.type}
                                    placeholder={i.placeholder}
                                    onChange={props.onChange}
                                    value={i.value}
                                    defaultValue={i.defaultValue}
                                    disabled={i.disabled}
                                    maxLength={i.maxLength}
                                    isNumber={i.isNumber}
                                />
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export interface InputRowProps {
    inputs: InputFieldProps[];
    /** HTML input `onChange` attribute */
    onChange?: React.ChangeEventHandler;
}
